import { useOnline } from '@vueuse/core';
import { ref, watch } from 'vue';
import { useErrorSnackbar } from '@/core/composables/useErrorSnackbar';

const isOnline = ref(true);
const isOfflineRequestErrorShow = ref(false);

type ReloadPageAlert = {
  icon?: string;
  title: string;
  subtitle: string;
  action?: () => void | Promise<void>;
};

const reloadPageAlert = ref<ReloadPageAlert | null>(null);

export const useAppState = () => {
  const { showErrorSnackbar, closeErrorSnackbar } = useErrorSnackbar();

  const online = useOnline();

  watch(online, () => {
    isOnline.value = online.value;

    if (!online.value) {
      showErrorSnackbar({
        title: 'Сеть недоступна. Проверьте ваше интернет-соединение',
        icon: 'offline',
      });
    } else {
      closeErrorSnackbar();
    }
  });

  const showOfflineRequestError = () => {
    isOfflineRequestErrorShow.value = true;
  };

  const showReloadPageAlert = (payload: ReloadPageAlert) => {
    reloadPageAlert.value = payload;
  };

  return {
    isOnline,

    isOfflineRequestErrorShow,
    showOfflineRequestError,

    reloadPageAlert,
    showReloadPageAlert,
  };
};
